/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
const { eventId, enableOffline = true } = window.__DATA__;

export const storagePrefix = `appcraft/${eventId}/platform/store`;

export function hasOfflineSupport(): boolean {
  return enableOffline;
}

export function getOffline(key: string): any {
  if (!hasOfflineSupport()) return null;
  const localKey = `${storagePrefix}/${key}`;
  const value = localStorage.getItem(localKey);
  if (!value) return undefined;
  if (value[0] === '{') {
    return JSON.parse(value);
  }
  return null;
}

export function putOffline(key: string, dataToSave: any): any {
  // Always save just in case we activate offline later on ?
  // if (!hasOfflineSupport()) return null;
  const localKey = `${storagePrefix}/${key}`;
  const valueToSave = JSON.stringify(dataToSave);
  localStorage.setItem(localKey, valueToSave);
}

export function flushEventStore(): void {
  const keysToFlush = [];
  // persist automatically prefixes keys
  const persistPrefix = `persist:${storagePrefix}`;
  for (const key in localStorage) {
    if (key.startsWith(persistPrefix) || key.startsWith(storagePrefix)) {
      keysToFlush.push(key);
    }
  }
  console.log('flush storage', keysToFlush);
  for (const key of keysToFlush) {
    localStorage.removeItem(key);
  }
}

(window as any).flushEventStore = flushEventStore;
